/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Attr_ThcInputs */

const en_attr_thc = /** @type {(inputs: Attr_ThcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THC`)
};

const th_attr_thc = /** @type {(inputs: Attr_ThcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THC`)
};

const ja_attr_thc = /** @type {(inputs: Attr_ThcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THC`)
};

const fr_attr_thc = /** @type {(inputs: Attr_ThcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THC`)
};

const es_attr_thc = /** @type {(inputs: Attr_ThcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THC`)
};

const ru_attr_thc = /** @type {(inputs: Attr_ThcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THC`)
};

const zh_attr_thc = /** @type {(inputs: Attr_ThcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THC`)
};

const vi_attr_thc = /** @type {(inputs: Attr_ThcInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`THC`)
};

/**
* | output |
* | --- |
* | "THC" |
*
* @param {Attr_ThcInputs} inputs
* @param {{ locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }} options
* @returns {LocalizedString}
*/
export const attr_thc = /** @type {((inputs?: Attr_ThcInputs, options?: { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Attr_ThcInputs, { locale?: "en" | "th" | "ja" | "fr" | "es" | "ru" | "zh" | "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_attr_thc(inputs)
	if (locale === "ja") return ja_attr_thc(inputs)
	if (locale === "fr") return fr_attr_thc(inputs)
	if (locale === "es") return es_attr_thc(inputs)
	if (locale === "ru") return ru_attr_thc(inputs)
	if (locale === "zh") return zh_attr_thc(inputs)
	if (locale === "vi") return vi_attr_thc(inputs)
	return en_attr_thc(inputs)
});